import { Select, Spin } from "antd";
import { useMemo, useRef, useState } from "react";
import debounce from "lodash/debounce";

export default function DebounceSelect({
    fetchOptions,
    labelInValue = true,
    minSize = 4,
    debounceTimeout = 300,
    ...props
}) {
    const [fetching, setFetching] = useState(false);
    const [options, setOptions] = useState([]);
    const fetchRef = useRef(0);
    const debounceFetcher = useMemo(() => {
        const loadOptions = (value) => {
            if (value.length >= minSize) {
                fetchRef.current += 1;
                const fetchId = fetchRef.current;
                setOptions([]);
                setFetching(true);
                fetchOptions(value).then((newOptions) => {
                    console.log(newOptions);
                    if (fetchId !== fetchRef.current) {
                        // for fetch callback order
                        return;
                    }
                    setOptions(newOptions);
                    setFetching(false);
                });
            } else {
                //setOptions([])
            }
        };
        return debounce(loadOptions, debounceTimeout);
    }, [fetchOptions, debounceTimeout]);
    return (
        <Select
            labelInValue={labelInValue}
            showSearch
            filterOption={false}
            onSearch={debounceFetcher}
            notFoundContent={fetching ? <Spin size="small" /> : "Nessun risultato"}
            {...props}
            options={options}
        />
    );
}
